import z from "zod";

const translationPath = "chatBot.page.automations.templateGeneral.errors.";

const templateGeneralTypeSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "templateGeneralType" },
);

export const templateGeneralsSchema = z.object({
  id: z.string().optional(),
  enable: z.boolean(),
  useHtml: z.boolean().optional(),
  name: z.string().min(1, translationPath + "name"),
  contentHeader: z.string().nullish(),
  contentFooter: z.string().nullish(),
  templateGeneralType: templateGeneralTypeSchema,
});

export type TTemplateGeneralsForm = z.infer<typeof templateGeneralsSchema>;
